var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import css from './style.pcss';
var RTLAutocompleteInput = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLAutocompleteInput, _LitElement);
  function RTLAutocompleteInput() {
    var _this;
    _classCallCheck(this, RTLAutocompleteInput);
    _this = _callSuper(this, RTLAutocompleteInput);
    _this.data = [];
    _this.value = '';
    _this.inputElem = null;
    _this.showList = false;
    return _this;
  }
  _createClass(RTLAutocompleteInput, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLAutocompleteInput.prototype), "connectedCallback", this).call(this);
      this.entries = JSON.parse(this.data);
    }
  }, {
    key: "onInput",
    value: function onInput(e) {
      this.inputElem = e.target;
      this.value = e.target.value;
      this.showList = true;
    }
  }, {
    key: "onClickItem",
    value: function onClickItem(e, value) {
      e.stopPropagation();
      this.value = value;
      this.inputElem.value = value;
      this.showList = false;
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var _this2 = this;
      if (!this.showList) return;
      var items = this.entries.filter(function (entry) {
        return entry.toLowerCase().includes(_this2.value.toLowerCase());
      }).map(function (entry) {
        return html(_t || (_t = _`<div class="rtl-autocomplete__item" @mousedown=${0}>${0}</div>`), function (e) {
          return _this2.onClickItem(e, entry);
        }, entry);
      });
      return html(_t2 || (_t2 = _`<div id="autocomplete-list" class="rtl-autocomplete__list">
            ${0}
        </div>`), items);
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut(e) {
      this.showList = false;
    }
  }, {
    key: "render",
    value: function render() {
      return html(_t3 || (_t3 = _`
            <style>${0}</style>
            <div class="rtl-autocomplete" style="width:100%;">
                <input
                    autocomplete="off"
                    style="width:100%"
                    @input="${0}"
                    @focusout="${0}"
                    type="text"
                    style="${0}"
                    class="${0}"
                    placeholder="${0}"
                    value="${0}"
                    name="${0}"
                >
                ${0}
            </div>`), css, this.onInput, this.onFocusOut, 'width:100%; ' + (this.inputStyle || ''), this.inputClass, this.placeholder || '', this.value, this.name || '', this.renderList());
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        value: {
          type: String
        },
        placeholder: {
          type: String
        },
        inputClass: {
          type: String
        },
        inputStyle: {
          type: String
        },
        showList: {
          type: Boolean
        },
        name: {
          type: String
        }
      };
    }
  }]);
  return RTLAutocompleteInput;
}(LitElement);
export { RTLAutocompleteInput as default };
window.customElements.define('rtl-autocomplete-input', RTLAutocompleteInput);